import { render, staticRenderFns } from "./titleSection.vue?vue&type=template&id=0f4a8f16&scoped=true&"
import script from "./titleSection.vue?vue&type=script&lang=js&"
export * from "./titleSection.vue?vue&type=script&lang=js&"
import style0 from "./titleSection.vue?vue&type=style&index=0&id=0f4a8f16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4a8f16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCardTitle,VIcon})
